import { useSelector } from 'react-redux';
import { selectNotify } from '../slices/notificationsSlice';
import { Snackbar } from '@gx-design/snackbar';

export const RTKNotify = () => {
    const notification = useSelector(selectNotify);

    if (!notification || !notification.message) {
        return null;
    }

    return (
        <Snackbar
            notification={
                notification || {
                    message: null,
                    type: null,
                }
            }
        />
    );
};
